import { render, staticRenderFns } from "./NotificationPaidInvoiceVerification.vue?vue&type=template&id=154c463f&scoped=true"
import script from "./NotificationPaidInvoiceVerification.vue?vue&type=script&lang=js"
export * from "./NotificationPaidInvoiceVerification.vue?vue&type=script&lang=js"
import style0 from "./NotificationPaidInvoiceVerification.vue?vue&type=style&index=0&id=154c463f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154c463f",
  null
  
)

export default component.exports